import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { dashboardStyles } from "./dashboard-styles";

type SectionCardProps = React.ComponentProps<typeof Card> & {
  variant?: "default" | "list";
};

export function SectionCard({
  className,
  variant = "default",
  ...props
}: SectionCardProps) {
  return (
    <Card
      className={cn(
        variant === "list" ? dashboardStyles.listSectionCard : dashboardStyles.sectionCard,
        className,
      )}
      {...props}
    />
  );
}
